import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Echodrift from "./components/Echodrift";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Echodrift />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
